import { render, staticRenderFns } from "./intelligenceAdd.vue?vue&type=template&id=3fd012c1&scoped=true&"
import script from "./intelligenceAdd.vue?vue&type=script&lang=js&"
export * from "./intelligenceAdd.vue?vue&type=script&lang=js&"
import style0 from "./intelligenceAdd.vue?vue&type=style&index=0&id=3fd012c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd012c1",
  null
  
)

export default component.exports